var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuitcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 18,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M8.938 0a2.063 2.063 0 0 0-2.063 2.063v.687H2.062A2.063 2.063 0 0 0 0 4.813v11a2.063 2.063 0 0 0 2.063 2.062h17.875A2.062 2.062 0 0 0 22 15.812v-11a2.062 2.062 0 0 0-2.063-2.062h-4.812v-.688A2.062 2.062 0 0 0 13.062 0H8.939Zm0 1.375h4.124a.687.687 0 0 1 .688.688v.687h-5.5v-.688a.688.688 0 0 1 .688-.687Zm2.593 9.507 9.094-2.424v7.354a.687.687 0 0 1-.688.688H2.063a.687.687 0 0 1-.687-.688V8.457l9.094 2.426a2.06 2.06 0 0 0 1.062 0ZM2.062 4.125h17.875a.687.687 0 0 1 .688.688v2.222l-9.448 2.518a.688.688 0 0 1-.354 0L1.375 7.034V4.814a.688.688 0 0 1 .688-.688Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuitcase);
export default __webpack_public_path__ + "static/media/suitcase.fff9fd80761a8c2834ee275913c1c7a3.svg";
export { ForwardRef as ReactComponent };